module.exports = __webpack_public_path__ + "static/img/bh.cc38a887.svg";